import { Icon } from "@blueprintjs/core"
import React, { memo } from "react"
import { useTranslation } from "react-i18next"

const ErrorWithRetry = ({
  errorMessage,
  onRetry,
}: {
  errorMessage: string
  onRetry: () => void
}) => {
  const { t } = useTranslation()
  return (
    <div className="flex h-[40px] flex-row gap-x-2">
      <Icon icon="error" size={20} color="red" />
      <p>{errorMessage}</p>
      <a onClick={onRetry} className="text-primary">
        {t("common.retry")}
      </a>
    </div>
  )
}

export default memo(ErrorWithRetry)
